import { Search, ArrowUpDown, SlidersHorizontal } from "lucide-react";
import { Input } from "@/app/components/input";

interface CategorySearchFiltersProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  currentLocation?: string;
  onLocationClick?: () => void;
  onSortClick?: () => void;
  onCustomFilterClick?: () => void;
  activeFiltersCount?: number;
}

export function CategorySearchFilters({
  searchQuery,
  onSearchChange,
  currentLocation = "Franca, São Paulo",
  onLocationClick,
  onSortClick,
  onCustomFilterClick,
  activeFiltersCount = 0,
}: CategorySearchFiltersProps) {
  return (
    <div className="bg-card border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {/* Location banner hidden for now; see backlog "Show location banner on search results". */}
        {false && currentLocation && onLocationClick && (
          <button
            onClick={onLocationClick}
            className="w-full mb-4 py-2 px-4 bg-secondary/50 hover:bg-secondary/70 rounded-lg transition-colors group flex items-center justify-center gap-2"
          >
            <span className="text-sm text-muted-foreground">
              Estamos buscando em:{" "}
              <span className="font-medium text-foreground">
                {currentLocation}
              </span>
            </span>
          </button>
        )}
        
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="flex-1 relative">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
            <Input
              type="search"
              placeholder="Buscar produtos..."
              className="pl-12"
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
            />
          </div>
          <div className="flex gap-2">
            {onCustomFilterClick && (
              <button 
                onClick={onCustomFilterClick}
                className="px-4 py-3 bg-secondary text-secondary-foreground rounded-lg hover:bg-secondary/80 transition-colors flex items-center justify-center gap-2 relative"
                title="Filtros"
              >
                <SlidersHorizontal className="w-5 h-5" />
                <span className="text-sm font-medium">Filtros</span>
                {activeFiltersCount > 0 && (
                  <span className="absolute -top-1 -right-1 w-5 h-5 bg-primary text-primary-foreground text-xs rounded-full flex items-center justify-center font-bold">
                    {activeFiltersCount}
                  </span>
                )}
              </button>
            )}
            {onSortClick && (
              <button 
                onClick={onSortClick}
                className="px-3 py-3 bg-secondary text-secondary-foreground rounded-lg hover:bg-secondary/80 transition-colors flex items-center justify-center"
                title="Ordenar"
              >
                <ArrowUpDown className="w-5 h-5" />
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
